import React from "react";
//import "./CogniHistorial.css";

const CogniHistorial = () => {
    const metrics = [
        { name: "Memoria", value: 85 },
        { name: "Atención", value: 72 },
        { name: "Velocidad de procesamiento", value: 68 },
        { name: "Funciones ejecutivas", value: 79 },
    ];

    const tags = [
        "Memoria",
        "Atención",
        "Velocidad de procesamiento",
        "Funciones ejecutivas",
    ];

    return (
        <div className="historial-container">
            <h2 className="historial-title">
                Historial de evaluaciones cognitivas
            </h2>

            <div className="historial-info-box">
                <p className="historial-info-box__date">
                    Última evaluación: <strong>15/02/2025</strong>
                </p>
                <p className="historial-info-box__desc">
                    Evaluación CAB (Cognitive Assessment Battery) general realizada por
                    Dr. Martínez
                </p>
            </div>

            <div className="historial-tags">
                {tags.map((tag) => (
                    <span key={tag} className="historial-tag">
            {tag}
          </span>
                ))}
            </div>

            <div className="historial-metrics">
                {metrics.map(({ name, value }) => (
                    <div key={name} className="historial-metric">
                        <div className="historial-metric__label">
                            <span>{name}</span>
                            <span>{value}%</span>
                        </div>
                        <div className="historial-metric__bar">
                            <div
                                className="historial-metric__fill"
                                style={{ width: `${value}%` }}
                            ></div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="historial-actions">
                <button className="btn btn-outline">Ver informe completo</button>
                <button className="btn btn-primary">
                    Comparar con evaluaciones anteriores
                </button>
            </div>
        </div>
    );
};

export default CogniHistorial;
